import type {FiltersHashmap} from '@Components/checkbox-filters/checkbox-filters.types';
import type {UserAvatarData} from '@Libraries/user-avatar.types';
import type {TeamInviteUpselling} from '@Panels/share-panel/components/add-to-team-card/add-to-team-card.types';

export const SHARE_PANEL_ID = 'share-panel';

export interface SharePanelProps {
  itemHashedId: string;
  type: ShareItemType;
  panelId: string;
}

export interface ShareDesignInfoResponse {
  posterHashedId: string;
  idUser: string;
  isSharedInTeam: boolean;
  shareLinkEditAccess: string;
  shareLinkViewAccess: string;
  invitationIdWithEditPermission: string;
  invitationIdWithViewPermission: string;
  previousContributorsInfo: ContributorInfo[];
  peopleWithAccess: DesignContributorInfo[];
  isShared: boolean;
  idDesignOwner: number;
  showShareInTeamBar?: boolean;
  showUpgradeToPremiumCard?: boolean;
  teamInviteUpselling?: TeamInviteUpselling | null;
  currentUserPermissionLevel: DesignPermissionLevel;
}

export interface ShareFolderInfoResponse {
  folderHashedId: string;
  idUser: string;
  isSharedInTeam: boolean;
  shareLink: string;
  invitationId: string;
  permissions: FolderPermissionLevel[];
  previousContributorsInfo: ContributorInfo[];
  peopleWithAccess: FolderContributorInfo[];
  idFolderOwner?: number;
  showShareInTeamBar?: boolean;
  showUpgradeToPremiumCard?: boolean;
  teamInviteUpselling?: TeamInviteUpselling | null;
}

export interface InviteLinkForPermissionsResponse {
  invitationId: string;
  shareLink: string;
}

export interface ContributorEmailInvitationResponse {
  numInvitesSent: number;
  emailsSentTo: string[];
}

export enum ShareItemType {
  POSTER = 'poster',
  FOLDER = 'folder',
}

export enum DesignPermissionLevelValue {
  EDIT = 'edit',
  VIEW = 'view',
}

export enum DesignPermissionLevel {
  NOT_SHARED,
  CAN_VIEW,
  CAN_EDIT,
  INVITE_SENT,
}

export enum FolderPermissionLevel {
  CAN_EDIT,
  CAN_ADD,
  CAN_COPY,
  CAN_INVITE,
  INVITE_SENT,
}

export enum FolderPermissionLevelValue {
  CAN_EDIT = 'can edit',
  CAN_ADD = 'can add',
  CAN_COPY = 'can copy',
  CAN_INVITE = 'can invite',
}

export interface ContributorInfo {
  avatar: UserAvatarData;
  name?: string;
  email: string;
  idUser?: number;
  isOwner?: boolean;
}

export interface DesignContributorInfo extends ContributorInfo {
  permissionLevel: DesignPermissionLevel;
}

export interface FolderContributorInfo extends ContributorInfo {
  permissionLevelsMap: FiltersHashmap;
}

export type ItemPermissionLevel = DesignPermissionLevel | FolderPermissionLevel;
